module.exports = __webpack_public_path__ + "img/video-2.9601a98a.png";